var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoMuted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.351 3.232a.792.792 0 0 0-1.12 1.12l1.836 1.835A2.375 2.375 0 0 0 3 8.542v7.916a2.375 2.375 0 0 0 2.375 2.375h8.708a2.375 2.375 0 0 0 2.186-1.445l4.38 4.38a.792.792 0 1 0 1.12-1.12l-5.536-5.535-.006-.006-8.709-8.709a1.014 1.014 0 0 0-.006-.006l-3.16-3.16Zm2.28 4.518 8.244 8.245v.463a.791.791 0 0 1-.792.792H5.375a.792.792 0 0 1-.792-.792V8.542a.792.792 0 0 1 .792-.792H6.63Zm4.808 0h2.644a.791.791 0 0 1 .792.792v2.644c0 .21.083.411.232.56l.792.791a.792.792 0 0 0 1.023.082l3.495-2.528v6.367a.792.792 0 1 0 1.583 0V8.542a.792.792 0 0 0-1.256-.642l-4.203 3.04-.083-.082V8.542a2.375 2.375 0 0 0-2.375-2.375H11.44a.792.792 0 1 0 0 1.583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMuted);
export default __webpack_public_path__ + "static/media/video-muted.9aec7ae3a0b1750866df52ad74096cf3.svg";
export { ForwardRef as ReactComponent };